import * as _ from 'lodash';
import { sortObj } from '../global/helpers/sort-helper';
import { Filter, FilterOption, ListItem, Sort, All, Empty } from './search-model';

export const addFilter = (option: FilterOption, filters: { [key: string]: Filter }) => {
	const updatedFilter = _.cloneDeep(filters);
	const filter = updatedFilter[option.filterKey];

	if (filter) {
		const match = filter.filterOptions?.filter(a => a.filterValue === option.filterValue)?.pop();
		if (!match) {
			filter.filterOptions.push(option);
		}
		updatedFilter[option.filterKey] = filter;
		return filters;
	}

	const newFilter: Filter = { filterKey: option?.filterKey, filterOptions: [option], partialMatch: false };

	updatedFilter[option.filterKey] = newFilter;
	return updatedFilter;

};

export const removeFilter = (option: FilterOption, filters: { [key: string]: Filter }) => {

	const updatedFilter = _.cloneDeep(filters);
	const filter = updatedFilter[option.filterKey];

	if (!filter) {
		return updatedFilter;
	}

	filter.filterOptions = filter.filterOptions?.filter(a => a.filterValue !== option.filterValue);
	updatedFilter[option.filterKey] = filter;
	return updatedFilter;
};




const isMatch = (listItem: ListItem, filters: { [key: string]: Filter }) => {
	let match = true;
	if (!filters) {
		return match;
	}
	const keys = Object.keys(filters);
	if (keys.length === 0) {
		return match;
	}

	for (let i = 0; i < keys.length; i += 1) {

		const key = keys[i];

		const values = listItem[key];
		const filterValues = filters[key]?.filterOptions?.map(a => a.filterValue)?.filter(b => b);
		if (filterValues?.includes(All)) {
			match = match && true;
		} else if (filterValues?.includes(Empty)) {
			match = false;
		} else if (filters[key]?.partialMatch) {
			match = match &&
				filters[key]?.
					filterOptions?.
					some(a => (listItem[a.filterKey])?.toString()?.toLowerCase()?.includes(a.filterValue?.toLowerCase()));
		} else if ((!values || values.length === 0) && filterValues?.length > 0) {
			match = false;
		} else if (Array.isArray(values) && filterValues?.length > 0) {
			match = match && values.filter(a => filterValues.includes(a.toString()))?.length > 0;
		} else if (typeof values === 'string' && filterValues?.length > 0) {
			match = match && filterValues.includes(values);
		}
	}

	return match;
};



export const filterList = (filters: { [key: string]: Filter }, list: ListItem[], sort?: Sort) => {

	const newList = list?.filter(a => isMatch(a, filters));

	return sort ? sortObj(newList, sort.prop, sort.descending) : newList;
};